import { z } from "zod"
import { OrganizationTypeEnum } from "../../companies/dtos"
import { Locale } from "../../employees/response_data"

export type OrganizationType = (typeof OrganizationTypeEnum)[keyof typeof OrganizationTypeEnum]

const BackofficeBaseCompanyResponseDataSchema = z.object({
  id: z.bigint().transform(String),
  organizationId: z.bigint().transform(String),
  name: z.string(),
  slug: z.string().nullable(),
  logo: z.string().nullable(),
  locale: z.enum(Locale),
  createdAt: z.date().transform((value) => value.toISOString()),
  updatedAt: z.date().transform((value) => value.toISOString()),
})

export const BackofficeGetCompanyResponseDataSchema =
  BackofficeBaseCompanyResponseDataSchema.extend(
    z.object({
      id: z.bigint().transform(String),
      additionalInfo: z.string().nullable(),
      description: z.string().nullable(),
      products: z.string().nullable().optional(),
      toneOfVoice: z.string().nullable().optional(),
    }).shape,
  )

export const BackofficeGetCompaniesResponseDataSchema = z.array(
  BackofficeBaseCompanyResponseDataSchema,
)

export const BackofficeCreateCompanyResponseDataSchema = z.object({
  company: z.object({ id: z.bigint().transform(String) }),
  organization: z.object({ id: z.bigint().transform(String) }),
  employee: z.object({ id: z.bigint().transform(String) }),
  customer: z.object({ id: z.bigint().transform(String) }).nullable(),
})

export const BackofficeImpersonateCompanyResponseDataSchema = z.object({
  token: z.string(),
})

export const BackofficeGetCompanyCreditsResponseDataSchema = z.object({
  packages: z.array(
    z.object({
      createdAt: z.date().transform((value) => value.toISOString()),
      credits: z.number(),
      remaining: z.number(),
      employeeName: z.string().optional().nullable(),
    }),
  ),
})
